import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

// Indian GSTIN: 15 chars — 2-digit state code + 10-char PAN + 1 entity code + 1 alphanum + 'Z' + 1 alphanum
const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

// Strip anything that isn't A-Z or 0-9, force uppercase, cap at 15 chars
const cleanGstInput = (raw) =>
    (raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);

const AssociationInformation = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const associationInfo = data || {};

    // GSTIN: must be exactly 15 chars AND match the GSTIN format if provided
    const gstValue = (associationInfo.gstRegNo || "").toString();
    const hasGstError = gstValue.length > 0 && (gstValue.length !== 15 || !GST_REGEX.test(gstValue));
    // Check for Local Authority Registration No. validation error (must be exactly 15 characters if provided)
    const hasLocalAuthError = associationInfo.localAuthorityRegNo && associationInfo.localAuthorityRegNo.length > 0 && associationInfo.localAuthorityRegNo.length !== 15;

    return (
        <InfoSection
            title="Association Information"
            icon="solar:users-group-rounded-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            hasError={hasGstError || hasLocalAuthError}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Association Name"
                    value={associationInfo.associationName}
                    icon="solar:buildings-3-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="associationName"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="GST Registration No."
                    value={associationInfo.gstRegNo}
                    icon="solar:document-add-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="gstRegNo"
                    onChange={onChange}
                    maxLength={15}
                    minLength={15}
                    pattern={GST_REGEX}
                    transform={cleanGstInput}
                    placeholder="e.g. 27AAFAM3538D1ZQ"
                    errorMessage="Invalid GSTIN format. Example: 27AAFAM3538D1ZQ"
                />
                <EditableInfoRow
                    label="Project Name"
                    value={associationInfo.projectName}
                    icon="solar:folder-with-files-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="projectName"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Local Authority Reg. No."
                    value={associationInfo.localAuthorityRegNo}
                    icon="solar:clipboard-list-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="localAuthorityRegNo"
                    onChange={onChange}
                    maxLength={15}
                    minLength={15}
                    errorMessage="Must be exactly 15 characters"
                />
                <EditableInfoRow
                    label="Property Tax Number"
                    value={associationInfo.propertyTaxNumber}
                    icon="solar:calculator-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="propertyTaxNumber"
                    onChange={onChange}
                />
            </div>
        </InfoSection>
    );
};

export default AssociationInformation;
